// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-4633112a]{display:inline-block}.container .preview[data-v-4633112a]{display:block;width:128px;height:128px}.container strong[data-v-4633112a]{display:block}\n", ""]);
// Exports
module.exports = exports;
